export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("crm-cards-sdk/lang/en.lyaml"));
vm(require("crm-component-utils/lang/en.lyaml"));
vm(require("customer-data-properties/lang/en.lyaml"));
at({ "en": { "crmStatistics": { "emptyState": "No data to display.", "error": { "noAssociationDefinitions": { "heading": "No association definitions were found for this object type pairing." } } } } });
};